import React from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { firstErrorMessage } from '@/utils/errors';
import Filter from '@/components/Filter';
import PublicVisibilityFilterToggles from '@/components/buttons/PublicVisibilityFilterToggles';
import { fetchRequestDatasets, updateRequestDatasetsFilter, updateRequestDatasetsFlags } from '../actions';
import { newRequest, resolveRequestWorkflow } from '../../state/state';

const RequestDatasetsFilters = ({
  category,
  className,
  code,
  commonsMode,
  fetchData,
  filterTerm,
  fluid,
  internalFlag,
  privateFlag,
  publicFlag,
  readErrors,
  updateFilterTerm,
  updateFlags,
}) => (
  <Filter
    fluid={fluid}
    className={clsx('aridhia-request-datasets-filter', className)}
    filterTerm={filterTerm}
    updateFilter={({ value }) => updateFilterTerm(category, code, value)}
    error={firstErrorMessage(readErrors)}
    onFilter={() => fetchData(category, code, 1, null, false)}
    label={(
      <PublicVisibilityFilterToggles
        commonsMode={commonsMode}
        entity="datasets"
        privateFlag={privateFlag}
        internalFlag={internalFlag}
        publicFlag={publicFlag}
        updateFlags={(flags) => updateFlags(category, code, flags)}
      />
)}
  />
);

const mapStateToProps = ({
  auth: { commonsMode },
  requests: { requests },
  workflows: { workflows },
}, ownProps) => {
  const { request } = resolveRequestWorkflow(requests, workflows, ownProps, newRequest(ownProps));
  const { datasets } = request.steps;

  return (
    {
      commonsMode,
      filterTerm: datasets.filter,
      privateFlag: datasets.privateFlag,
      internalFlag: datasets.internalFlag,
      publicFlag: datasets.publicFlag,
      readErrors: datasets.readErrors,
    }
  );
};

const mapDispatchToProps = {
  updateFlags: updateRequestDatasetsFlags,
  updateFilterTerm: updateRequestDatasetsFilter,
  fetchData: fetchRequestDatasets,
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestDatasetsFilters);
